<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">任务下发</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <el-form-item label="输入任务">
          <el-select
            :style="inlineItemStyle25"
            v-model="ruleform.baseTaskId"
            v-on:change="currentTaskSelectChange"
            placeholder="选择任务"
          >
            <el-option
              v-for="item in tableData"
              :key="item.id"
              :label="item.taskName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            :style="inlineItemStyle25"
            v-model="ruleform.insertType"
            v-on:change="currentPositionSelectChange"
            placeholder="选择位置"
          >
            <el-option
              v-for="item in positions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务名称" prop="taskName">
          <el-input :style="inlineItemStyle80" v-model="ruleform.taskName"></el-input>
        </el-form-item>
        <el-form-item label="任务描述" prop="taskDesc">
          <el-input :style="inlineItemStyle80" type="textarea" rows="2" v-model="ruleform.taskDesc"></el-input>
        </el-form-item>
        <el-form-item label="任务地址" prop="taskAddress">
          <el-input :style="inlineItemStyle50" v-model="ruleform.taskAddress"></el-input>
        </el-form-item>
        <el-form-item label="计划响应时间" prop="responseMinute">
          <el-input-number :min="0" v-model="ruleform.responseMinute" controls-position="right"></el-input-number>
          <label>分钟</label>
        </el-form-item>
        <el-form-item label="经纬度">
          <el-input :style="inlineItemStyle25" v-model="ruleform.longitude"></el-input>
          <el-input :style="inlineItemStyle25" v-model="ruleform.latitude"></el-input>
          <ZjLngLatSelect
            class="newtaskposition"
            :point_lat="ruleform.latitude"
            :point_lng="ruleform.longitude"
            @onGotLngLat="onGotLngLat"
          ></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="负责人" style="display: inline-block">
          <el-select
            style="width: 40rem"
            v-model="ruleform.personId"
            v-bind:disabled="IsEdit"
            @change="handleCheckedChange"
          >
            <el-option-group
              v-for="group in UsersOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="smsPerson">
          <div>任务会通过短信的形式发送给相关人员</div>
          <!-- <div
            :style="{ margin: '2px 0px'}"
            v-for="(item,index) in ruleform.smsPerson"
            :key="index"
          >
            <el-input
              :style="inlineItemStyle50"
              v-model="item.Phone"
            ></el-input>
            <el-button :style="{ 'background-color':'transparent'}" @click="addContact()">添加</el-button>
            <el-button
              :style="{ color:'#f04a4c', 'background-color':'transparent', 'border-color':'#f04a4c'}"
              @click="removeContact(index)"
            >删除</el-button>
          </div> -->
          <div>
            从应急通信录选择
            <i
              @click="isshow = !isshow"
              :class="isshow?'el-icon-arrow-up':'el-icon-arrow-down'"
            ></i>
          </div>
          <UserTabControl v-if="isshow" ref="userTabls" :form="form"/>
        </el-form-item>
      </zj-layout-container>
      <zj-layout-container class="footer">
        <el-form-item class="btns">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleform')">提交</el-button>
        </el-form-item>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
const utils = ZJApp.ZJUtils;
import UserTabControl from "../../Plan/UserTabControl";
// eslint-disable-next-line no-unused-vars
import { getDictionary } from "@/api/src/emergency_common";
import { list } from "@/api/src/emergency_person";
import { save } from "@/api/src/emergency_command_task";
export default {
  name: "ZJEmergencyComponentNewTask",
  componentName: "ZJEmergencyComponentNewTask",
  components: {
    UserTabControl: UserTabControl
  },
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    tableData: {
      type: Object,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      inlineItemStyle25: {
        width: "25%",
        "margin-right": "2rem"
      },
      inlineItemStyle50: {
        width: "50%",
        "margin-right": "2rem"
      },
      inlineItemStyle80: {
        width: "80%",
        "margin-right": "2rem"
      },
      isshow: false,
      positions: [
        { label: "之前插入", value: "1" },
        { label: "之后插入", value: "2" },
      ],
      ruleform: {
        eventId: this.ExecutId,
        taskName: "",
        taskDesc: "",
        responseMinute: 0,
        status: 1,
        taskAddress: "",
        longitude: 0,
        latitude: 0,
        smsPerson: '',
        personId: "",
        mobileNo: "",
        taskType: 2,
        taskExecuteMode: 1
      },
      rules: {
        taskName: [
          { required: true, message: "请选择任务名称", trigger: "blur" }
        ],
        taskDesc: [
          { required: true, message: "请填写任务描述", trigger: "blur" },
          {
            min: 0,
            max: 1000,
            message: "长度最长为1000个字符",
            trigger: "blur"
          }
        ],
        smsPerson: [
          {
            type: "array",
            required: true,
            validator: this.validphone,
            trigger: "blur"
          }
        ]
      },
      startTaskMsgKey: "MessageKey_EmergencyEventStartTask",
      UsersOptions: [],
      form:{
        sms:''
      }
    };
  },
  created(){
    utils
      .waitAll([
        getDictionary('task_execute_mode'),
        getDictionary('organization_type'),
        list({
          page:1,
          size:10000,
        }),
      ])
      .then((r) => {
         let data = r[0].data.records;
        this.ruleform.taskExecuteMode = data[0].code;
        this.GetUserData(r[1].data.records, r[2].data.records);
        return r;
      })
      .catch((e) => {
        console.error(e);
      });
  },
  methods: {
    GetUserData(Fatoption, Chiloption) {
      this.ChildUser = Chiloption;
      var userOpt = [];
      for (var i = 0; i < Fatoption.length; i++) {
        var item = Fatoption[i];
        var users = [];
        for (var j = 0; j < Chiloption.length; j++) {
          var user = Chiloption[j];
          if (user.belongDeptType == item.code) {
            users.push({ value: user.id, label: user.name });
          }
        }
        userOpt.push({
          label: item.value,
          options: users,
        });
      }
      this.UsersOptions = userOpt;
    },
    handleCheckedChange(value) {
      for (var j = 0; j < this.ChildUser.length; j++) {
        var user = this.ChildUser[j];
        if (user.id == value) {
          this.ruleform.mobileNo = user.contactNo;
          break;
        }
      }
    },
    validphone: function(rule, value, callback) {
      console.log("validphone");
      if (this.getUserIds().length==0 && (value.length>0 && value[0].Phone=="")) {
        callback(new Error("请输入电话号码"));
      } else if (value.length>0 && value[0].Phone!="" &&!this.validphonelist(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    validphonelist(arr) {
      var result = arr.every(function(item) {
        return ZJApp.ZJUtils.isRightMobileNum(item.Phone);
      });
      return result;
    },
    submitForm(formName) {
      let that = this;

      this.$refs[formName].validate().then(valid => {
        if (valid) {
          //插入反馈数据
          var userids = this.getUserIds();
          this.ruleform.smsPerson = JSON.stringify(userids)
          save(this.ruleform)
            .then(r => {
              let code = r.code;
              if (code == 0) {
                var msgcontent = {
                  key: this.startTaskMsgKey,
                  data:''
                };
                this.$notify.broadcase(msgcontent);
                that.$message({
                  message: r.msg ? r.msg : "下发任务成功！",
                  type: "success"
                });
                //关闭当前弹窗
                that.$emit("handlerclose");
              } else {
                that.$message({
                  message: r.msg ? r.msg : "下发任务失败！",
                  type: "error"
                });
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      });
    },
    addContact() {
      this.ruleform.smsPerson.push('');
    },
    removeContact(index) {
      if (this.ruleform.smsPerson.length > 1) {
        this.ruleform.smsPerson.splice(index, 1);
      }
    },
    onBack: function() {
      this.$emit("handlerclose");
    },
    onGotLngLat(obj) {
      this.ruleform.latitude = obj.lat || 0;
      this.ruleform.longitude = obj.lng || 0;
    },
    getUserIds() {
      let userids = [];
      var chil = this.$refs["userTabls"];
      if(chil && chil.GetOrgUserIds)
      {
         userids = chil.GetOrgUserIds();
      }
      return userids;
    },
    currentTaskSelectChange(value) {
      console.log(value);
    },
    currentPositionSelectChange(value) {
      console.log(value);
    }
  }
};
</script>